import { types, actions } from './requests'
export const GETWORKLISTFILTER_TYPES = {
    ...types('GETWORKLISTFILTER'),
}
export const GETWORKLISTFILTER_ACTIONS = {
    ...actions('GETWORKLISTFILTER'),
}
